import React, { useState } from "react";
import { View, Text, StyleSheet, Platform } from "react-native";
import moment from "moment";
import AppTheme from "../../AppTheme";

import ImageComponent from "../../common/ImageComponent";
import { getAllUsers } from "../../users/UsersHelper";
import SnoozeOptions from "../../common/SnoozeOptions";
import SnoozeIcon from "../../common/dialog/SnoozeIcon";
import HiddenIcon from "../../common/icons/integrations/HiddenIcon";
import EditWhitePencil from "../../common/icons/integrations/EditWhitePencil";
import Icons from "../../common/icons";
import MoodColors from "../../common/mood/MoodColors";

export default function ReportComment({
  controller,
  comment = {},
  onEditComment = () => {},
  deleteComment = () => {},
  marAsUnread = () => {},
}) {
  const [showSnoozeOptions, setShowSnoozeOptions] = useState(false);

  const { email_from, datetime_created, message } = comment;
  const commentDate = moment(datetime_created).format("hh:mm a, MM/DD/YY");

  const users = getAllUsers(controller);
  const user = users[email_from] || { name: email_from };
  const displayUserText = user.name;

  const isOwner = email_from === controller?.state?.currentUser;

  const menuOptions = !isOwner
    ? [
        {
          name: "Mark as unread",
          icon: (
            <HiddenIcon
              width={16}
              height={16}
              color={AppTheme.almostBlack}
              color2={AppTheme.almostBlack}
            />
          ),
        },
      ]
    : [
        {
          name: "Edit",
          icon: (
            <EditWhitePencil
              fillColor={AppTheme.almostBlack}
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Delete forever",
          style: {
            color: MoodColors.VeryBad,
          },
          icon: (
            <Icons.Dismiss
              styles={{
                justifyContent: "center",
              }}
              width={12}
              height={12}
            />
          ),
        },
      ];

  const onSnooze = (opt) => {
    if (opt === "Edit") onEditComment(comment);
    if (opt === "Delete forever") deleteComment(comment);
    if (opt === "Mark as unread") marAsUnread(comment);

    setShowSnoozeOptions(false);
  };

  return (
    <View style={[styles.commentContainer, styles.shadow]}>
      {showSnoozeOptions ? (
        <SnoozeOptions
          style={{ opacity: 1, top: 0, right: 10 }}
          showSnoozed
          customOptions={menuOptions}
          onSnooze={onSnooze}
          disableOverlay
        />
      ) : null}

      <View style={[styles.left, { marginRight: 8 }]}>
        {/* Avatar */}
        {user?.avatar ? (
          <ImageComponent image={user.avatar} style={styles.avatar} />
        ) : (
          <View style={styles.avatar} />
        )}
      </View>

      <View style={[styles.right]}>
        {/* User */}
        <Text style={styles.userName} numberOfLines={1}>
          {displayUserText}
        </Text>

        {/* Date sent */}
        <Text style={styles.date}>Sent at {commentDate}</Text>

        {/* Comment */}
        <Text style={styles.text}>{message}</Text>
      </View>

      <SnoozeIcon
        onPress={() => setShowSnoozeOptions(true)}
        style={styles.moreIcon}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  commentContainer: {
    position: "relative",
    minHeight: 76,
    flexDirection: "row",
    paddingLeft: 8,
    paddingRight: 20,
    paddingVertical: 8,
    marginHorizontal: 8,
  },
  shadow: {
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 4 },
    shadowColor: "#000",
    shadowRadius: 3,
    elevation: 5,
    borderRadius: 4,
    backgroundColor: "#FFF",
    marginBottom: 8,
  },
  reply: {
    textAlign: "right",
  },
  flex: {
    display: "flex",
  },
  left: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  right: {
    position: "relative",
    display: "flex",
    flex: 1,
  },
  avatar: {
    width: 28,
    height: 28,
    borderRadius: 28,
    marginBottom: 4,
    backgroundColor: "lightgray",
  },
  userName: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    marginBottom: 2,
  },
  text: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  date: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    marginBottom: 3,
  },
  moreIcon: {
    position: "absolute",
    right: 4,
    top: 4,
    width: 15,
    height: 15,
  },
});
